// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { PartyCredentialRequirement } from '@daml.js/utility-credential-v0/lib/Utility/Credential/V0/Credential';
import { OperatorConfiguration } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Configuration/Operator';
import { CreateEvent } from '@daml/ledger';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useCreateOperatorConfiguration: () => UseMutationResult<
  CreateEvent<OperatorConfiguration>,
  string,
  {
    providerRequirements: PartyCredentialRequirement[];
  }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();

  return useMutation({
    mutationKey: ['createOperatorConfiguraiton', ledgerApi],
    mutationFn: async ({ providerRequirements }) => {
      return ledgerApi.createRegistryOperatorConfiguration(operator, providerRequirements);
    },
  });
};

export default useCreateOperatorConfiguration;
